import { 
    GET_ALL_REFERRAL_LEDGER_REQUEST,
    GET_ALL_REFERRAL_LEDGER_SUCCESS,
    GET_REFERRAL_LEDGER_SUCCESS,
    GET_REFERRAL_LEDGER_STATS_SUCCESS,
    GET_USER_REFERRALS_SUCCESS,
    GET_USER_REFERRED_BY_SUCCESS,
    CREATE_REFERRAL_LEDGER_SUCCESS,
    UPDATE_REFERRAL_LEDGER_SUCCESS,
    DELETE_REFERRAL_LEDGER_SUCCESS,
    COMPLETE_REFERRAL_SUCCESS,
    CANCEL_REFERRAL_SUCCESS,
    REFERRAL_LEDGER_ERROR,
    REFERRAL_LEDGER_LOADING
} from '../actions/types';

const initialState = {
    referralLedger: [],
    currentReferralLedger: null,
    stats: null,
    userReferrals: [],
    userReferredBy: [],
    loading: true,
    error: null,
    pagination: {
        page: 1,
        limit: 10,
        total: 0,
        pages: 0
    }
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_ALL_REFERRAL_LEDGER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_ALL_REFERRAL_LEDGER_SUCCESS:
            return {
                ...state,
                referralLedger: payload.data || [],
                pagination: payload.pagination || state.pagination,
                loading: false,
                error: null
            };

        case GET_REFERRAL_LEDGER_SUCCESS:
            return {
                ...state,
                currentReferralLedger: payload,
                loading: false,
                error: null
            };

        case GET_REFERRAL_LEDGER_STATS_SUCCESS:
            return {
                ...state,
                stats: payload,
                loading: false,
                error: null
            };

        case GET_USER_REFERRALS_SUCCESS:
            return {
                ...state,
                userReferrals: payload.data || [],
                loading: false,
                error: null
            };

        case GET_USER_REFERRED_BY_SUCCESS:
            return {
                ...state,
                userReferredBy: payload.data || [],
                loading: false,
                error: null
            };

        case CREATE_REFERRAL_LEDGER_SUCCESS:
            return {
                ...state,
                referralLedger: [payload, ...state.referralLedger],
                loading: false,
                error: null
            };

        case UPDATE_REFERRAL_LEDGER_SUCCESS:
            return {
                ...state,
                referralLedger: state.referralLedger.map(item => 
                    item._id === payload._id ? payload : item
                ),
                currentReferralLedger: state.currentReferralLedger && 
                    state.currentReferralLedger._id === payload._id ? payload : state.currentReferralLedger,
                loading: false,
                error: null
            };

        case DELETE_REFERRAL_LEDGER_SUCCESS:
            return {
                ...state,
                referralLedger: state.referralLedger.filter(item => item._id !== payload),
                currentReferralLedger: state.currentReferralLedger && 
                    state.currentReferralLedger._id === payload ? null : state.currentReferralLedger,
                loading: false,
                error: null
            };

        case COMPLETE_REFERRAL_SUCCESS:
            return {
                ...state,
                referralLedger: state.referralLedger.map(item => 
                    item._id === payload._id ? payload : item
                ),
                currentReferralLedger: state.currentReferralLedger && 
                    state.currentReferralLedger._id === payload._id ? payload : state.currentReferralLedger,
                loading: false,
                error: null
            };

        case CANCEL_REFERRAL_SUCCESS:
            return {
                ...state,
                referralLedger: state.referralLedger.map(item => 
                    item._id === payload._id ? payload : item
                ),
                currentReferralLedger: state.currentReferralLedger && 
                    state.currentReferralLedger._id === payload._id ? payload : state.currentReferralLedger,
                loading: false,
                error: null
            };

        case REFERRAL_LEDGER_ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };

        case REFERRAL_LEDGER_LOADING:
            return {
                ...state,
                loading: payload
            };

        default:
            return state;
    }
};
